---
de:
  api_key: API-Schlüssel
  api_keys: API-Schlüssel
  api_keys_company_access_limit: Es werden die ersten %{count} Unternehmen angezeigt. Verwende die Suche, um weitere zu finden.
  api_keys_confirm_rotate: Das Rotieren des Tokens macht den vorhandenen Schlüssel ungültig. Fortfahren?
  api_keys_toast:
    copied: Token in die Zwischenablage kopiert
    create_failed: API-Schlüssel konnte nicht erstellt werden
    created: API-Schlüssel erstellt
    delete_failed: API-Schlüssel konnte nicht gelöscht werden
    deleted: API-Schlüssel gelöscht
    export_started: Export gestartet - wir informieren per E-Mail, sobald er fertig ist
    rotate_failed: API-Schlüssel-Token konnte nicht erneuert werden
    rotated: API-Schlüssel-Token erneuert
    update_failed: API-Schlüssel konnte nicht aktualisiert werden
    updated: API-Schlüssel aktualisiert
  api_keys_token_too_short: Token muss mindestens {count} Zeichen lang sein
  company_access_hint: Wählen Sie die Unternehmen aus, auf die der API-Benutzer Zugriff haben soll
  current_access: Aktueller Zugang
  expensive_req: die teuersten anfragen der letzten 7 tage
  recent_request: aktuellste anfragen
